/**
 * When true, show dropdown arrows for Organize and Prioritize (desktop)
 * and allow opening their menus via long-press on mobile.
 * When false, dropdowns are hidden and long-press does nothing.
 */
export const SHOW_ORGANIZE_PRIORITIZE_DROPDOWNS = false;

/**
 * When true, show the task edit toolbar (status, indent/outdent, due date) below the task when editing.
 * When false, the toolbar is hidden entirely.
 */
export const SHOW_TASK_EDIT_TOOLBAR = true;

/**
 * Task edit toolbar status UI:
 * - false: show all status icons inline (current behaviour)
 * - true: show a single dropdown to select custom status
 */
export const TASK_EDIT_TOOLBAR_STATUS_AS_DROPDOWN = true;

/**
 * When true (and SHOW_TASK_EDIT_TOOLBAR is true), the toolbar is shown inline to the right of the task text,
 * before the due date—no background, border or shadow; reduced spacing.
 * When false, the toolbar is shown below the task as a floating bar.
 */
export const TASK_EDIT_TOOLBAR_INLINE = true;

/**
 * When true (and TASK_EDIT_TOOLBAR_INLINE is true), the inline toolbar is only shown on desktop;
 * on mobile the floating toolbar below the task is used instead.
 * When false, the inline toolbar is shown on both desktop and mobile when TASK_EDIT_TOOLBAR_INLINE is on.
 */
export const TASK_EDIT_TOOLBAR_INLINE_DESKTOP_ONLY = false;

/**
 * When true, show "Add task..." after the last task and after the last subtask in a group.
 * Clicking it adds a new task above the button and focuses it for editing.
 */
export const SHOW_ADD_TASK_BUTTON = true;

/**
 * When true, hide the "Example lists" section in the sidebar when the user is logged out.
 * When false, example lists are shown when logged out (default behaviour).
 */
export const HIDE_EXAMPLE_LISTS_WHEN_LOGGED_OUT = true;

/**
 * Controls the "top-toolbar" variant (task edit toolbar inside the top header).
 * ON for all desktop viewports; OFF on mobile (max-width 768px) and during SSR.
 */
export function getTopToolbarFlag({ isMobileViewport = null } = {}) {
  if (typeof window === 'undefined') return false;

  const isMobile =
    typeof isMobileViewport === 'boolean'
      ? isMobileViewport
      : window.matchMedia('(max-width: 768px)').matches;

  return !isMobile;
}
